import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

import { FormLabel } from '../../../../elements';
import { StyledTextarea } from '../../../../styles';
import AlertDialog from '../../AlertDialog';

const UpdateInvoiceNumberModal = ({
  confirmHandler, dismissHandler, modal: { items, open, data },
}) => {
  const [invoiceNumber, updateInvoiceNumber] = useState('');

  useEffect(() => {
    updateInvoiceNumber(data);
  }, [data]);


  const modalConfirmHandler = () => {
    confirmHandler(items, invoiceNumber);
  };

  const modalDismissHandler = () => {
    dismissHandler();
    updateInvoiceNumber('');
  };

  const commentChangeHandler = (event) => {
    updateInvoiceNumber(event.target.value);
  };

  return (
    <AlertDialog
      title="Update invoice number"
      open={!!open}
      confirmTitle="Update"
      onConfirmation={modalConfirmHandler}
      onDismiss={modalDismissHandler}
    >
      <div className="FormRowInline">
        <FormLabel title="Invoice number" labelAbove>
          <StyledTextarea onChange={commentChangeHandler} value={invoiceNumber || ''} data-testid="invoice-comment" />
        </FormLabel>
      </div>
    </AlertDialog>
  );
};

UpdateInvoiceNumberModal.propTypes = {
  modal: PropTypes.shape({
    open: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    ),
  }),
  confirmHandler: PropTypes.func,
  dismissHandler: PropTypes.func,
};

export default UpdateInvoiceNumberModal;
